import FacturesFournisseursTab from "@features/comptabilite/components/factures/FacturesFournisseursTab";
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/factures-fournisseurs/")({
  staticData: {
    title: "Factures fournisseurs",
    icon: FileText,
    tab_icon: FileText,
    module: "comptabilite",
    order: 30,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: FacturesFournisseursTab,
});
